(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function track(name, data) {
      if (typeof window.gtag === 'function') window.gtag('event', name, data);
      if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, data);
    }
    function slideData(slideEl) {
      var link = slideEl.querySelector('.sf-slider__link');
      return {
        position: Number(slideEl.getAttribute('data-slide')) + 1,
        slide_type: slideEl.getAttribute('data-slide-type') || '',
        link_url: link ? link.getAttribute('href') : '',
      };
    }
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.sf-slider__link');
      if (!link) return;
      var slideEl = link.closest('.swiper-slide');
      if (!slideEl) return;
      track('home_banner_click', slideData(slideEl));
    });
    if ('IntersectionObserver' in window) {
      var seen = new WeakSet();
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !seen.has(entry.target)) {
              seen.add(entry.target);
              track('home_banner_impression', slideData(entry.target));
            }
          });
        },
        { threshold: 0.5 }
      );
      document
        .querySelectorAll('[data-section-type="slider"] .swiper-slide:not(.swiper-slide-duplicate)')
        .forEach(function (slideEl) {
          observer.observe(slideEl);
        });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
